import React, { type ReactNode } from "react";
import { Card, Typography } from "antd";

type MetricCardProps = {
  title: string;
  value: string | number;
  helper: string;
  icon: ReactNode;
  accent: string;
  loading?: boolean;
};

export const MetricCard = ({ title, value, helper, icon, accent, loading }: MetricCardProps): React.ReactElement => (
  <Card
    loading={loading}
    styles={{ body: { padding: 20 } }}
    className="h-full overflow-hidden rounded-lg border border-gray-200 shadow-sm"
  >
    <div className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <Typography.Text className="text-xs font-medium uppercase tracking-wide text-gray-500">{title}</Typography.Text>
        <div className="mt-3 truncate text-3xl font-semibold tracking-normal text-gray-950">{value}</div>
      </div>
      <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${accent}`}>{icon}</div>
    </div>
    <Typography.Text className="mt-4 block text-sm text-gray-500">{helper}</Typography.Text>
  </Card>
);
